/**
 * Reads picking list row payload passed via React Router location.state.
 */
export const getPickingOrderDetailFromLocation = (location) => {
  const state = location?.state
  if (!state?.pickingOrderDetail) {
    return null
  }
  return state.pickingOrderDetail
}

export default getPickingOrderDetailFromLocation
